import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layout, Menu } from 'antd';
import {
  DashboardOutlined,
  UserOutlined,
  ShopOutlined,
  AppstoreOutlined,
  FileDoneOutlined,
  ShoppingOutlined,
  CalendarOutlined,
  HeartOutlined,
  TagsOutlined,
  BulbOutlined,
  QuestionCircleOutlined,
  FileTextOutlined,
  StarOutlined,
  GiftOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;

const AdminSidebar = ({ collapsed, onCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Get current selected key based on path
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path === '/admin/dashboard') return 'dashboard';
    if (path.includes('/admin/users')) return 'users';
    if (path.includes('/admin/partners')) return 'partners';
    if (path.includes('/admin/products')) return 'products';
    if (path.includes('/admin/services')) return 'services';
    if (path.includes('/admin/orders')) return 'orders';
    if (path.includes('/admin/appointments')) return 'appointments';
    if (path.includes('/admin/animals')) return 'animals';
    if (path.includes('/admin/animal-categories')) return 'animal-categories';
    if (path.includes('/admin/breeds')) return 'breeds';
    if (path.includes('/admin/category-suggestions')) return 'category-suggestions';
    if (path.includes('/admin/service-categories')) return 'service-categories';
    if (path.includes('/admin/product-categories')) return 'product-categories';
    if (path.includes('/admin/ngos')) return 'ngos';
    if (path.includes('/admin/invoices')) return 'invoices';
    if (path.includes('/admin/inquiries')) return 'inquiries';
    if (path.includes('/admin/reviews')) return 'reviews';
    if (path.includes('/admin/coupons')) return 'coupons';
    return 'dashboard';
  };

  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: t('admin.sidebar.dashboard'),
      onClick: () => navigate('/admin/dashboard'),
    },
    {
      type: 'divider',
    },
    {
      key: 'users-group',
      icon: <UserOutlined />,
      label: t('admin.sidebar.usersGroup'),
      children: [
        {
          key: 'users',
          label: t('admin.sidebar.users'),
          onClick: () => navigate('/admin/users'),
        },
        {
          key: 'partners',
          icon: <ShopOutlined />,
          label: t('admin.sidebar.partners'),
          onClick: () => navigate('/admin/partners'),
        },
      ],
    },
    {
      key: 'catalog-group',
      icon: <AppstoreOutlined />,
      label: t('admin.sidebar.catalogGroup'),
      children: [
        {
          key: 'products',
          label: t('admin.sidebar.products'),
          onClick: () => navigate('/admin/products'),
        },
        {
          key: 'services',
          icon: <FileDoneOutlined />,
          label: t('admin.sidebar.services'),
          onClick: () => navigate('/admin/services'),
        },
        {
          key: 'product-categories',
          label: t('admin.sidebar.productCategories'),
          onClick: () => navigate('/admin/product-categories'),
        },
        {
          key: 'service-categories',
          label: t('admin.sidebar.serviceCategories'),
          onClick: () => navigate('/admin/service-categories'),
        },
      ],
    },
    {
      key: 'orders-group',
      icon: <ShoppingOutlined />,
      label: t('admin.sidebar.ordersGroup'),
      children: [
        {
          key: 'orders',
          label: t('admin.sidebar.orders'),
          onClick: () => navigate('/admin/orders'),
        },
        {
          key: 'appointments',
          icon: <CalendarOutlined />,
          label: t('admin.sidebar.appointments'),
          onClick: () => navigate('/admin/appointments'),
        },
      ],
    },
    {
      key: 'animals-group',
      icon: <HeartOutlined />,
      label: t('admin.sidebar.animalsGroup'),
      children: [
        {
          key: 'animals',
          label: t('admin.sidebar.animals'),
          onClick: () => navigate('/admin/animals'),
        },
        {
          key: 'animal-categories',
          icon: <TagsOutlined />,
          label: t('admin.sidebar.animalCategories'),
          onClick: () => navigate('/admin/animal-categories'),
        },
        {
          key: 'breeds',
          label: t('admin.sidebar.breeds'),
          onClick: () => navigate('/admin/breeds'),
        },
        {
          key: 'category-suggestions',
          icon: <BulbOutlined />,
          label: t('admin.sidebar.categorySuggestions'),
          onClick: () => navigate('/admin/category-suggestions'),
        },
      ],
    },
    {
      type: 'divider',
    },
    {
      key: 'ngos',
      icon: <HeartOutlined style={{ color: '#eb2f96' }} />,
      label: t('admin.sidebar.ngos'),
      onClick: () => navigate('/admin/ngos'),
    },
    {
      key: 'invoices',
      icon: <FileTextOutlined />,
      label: t('admin.sidebar.invoices'),
      onClick: () => navigate('/admin/invoices'),
    },
    {
      key: 'inquiries',
      icon: <QuestionCircleOutlined />,
      label: t('admin.sidebar.inquiries'),
      onClick: () => navigate('/admin/inquiries'),
    },
    {
      key: 'reviews',
      icon: <StarOutlined />,
      label: t('admin.sidebar.reviews'),
      onClick: () => navigate('/admin/reviews'),
    },
    {
      key: 'coupons',
      icon: <GiftOutlined />,
      label: t('admin.sidebar.coupons'),
      onClick: () => navigate('/admin/coupons'),
    },
  ];

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      width={260}
      className="admin-sidebar"
      style={{
        background: '#fff',
        borderRight: '1px solid #f0f0f0',
      }}
    >
      <Menu
        mode="inline"
        selectedKeys={[getSelectedKey()]}
        defaultOpenKeys={['users-group', 'catalog-group', 'orders-group', 'animals-group']}
        items={menuItems}
        style={{ borderRight: 0, paddingTop: 16 }}
      />
    </Sider>
  );
};

export default AdminSidebar;
